module.exports = __webpack_public_path__ + "7d8cbbb99181e6b16584ba6520eaa9d2.svg";